import React, { useEffect, useState } from "react";
import { FaSquare, FaCheckSquare, FaMinusSquare } from "react-icons/fa";
import { IoMdArrowDropright } from "react-icons/io";
import TreeView, { flattenTree } from "react-accessible-treeview";
import cx from "classnames";
import { Card, CardHeader, CardBody } from "../../../components/card/card";
import { useAuth } from "../../../contexts/AuthContext";
import { location, machineProfile } from "../../../api";
import { parserAPI } from "../../../utils/parser";
import { toast } from "react-toastify";
import {
  formatDateOnly,
  generateLocationToArray,
  Loader,
} from "../../../utils/helper";
import ImageViewer from "../../../components/ImageViewer";
import { useNavigate } from "react-router-dom";

function StructureView({ clickMachine }) {
  const { updateMachineProfile } = useAuth();
  const [changeStatus, setChangeStatus] = useState(null);
  const canUpdate = updateMachineProfile();
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingMachine, setLoadingMachine] = useState(true);
  const [expandedIds, setExpandedIds] = useState([]);
  const { getLocationName } = useAuth();
  const [locations, setLocations] = useState(null);
  const navigate = useNavigate();
  const [datas, setDatas] = useState([]);
  const [selectedMachine, setSelectedMachine] = useState(null);
  const [query, setQuery] = useState({ company: true });

  async function getMachine(id) {
    try {
      setLoadingMachine(true);
      const res = await machineProfile.getOne(id);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data) {
          setSelectedMachine(data);
        }
      }
      setLoadingMachine(false);
    } catch (e) {
      setLoadingMachine(false);
      toast.error(e.message);
      console.error(e);
    }
  }

  function openChangeStatus(value) {
    setChangeStatus(value);
  }

  function hideChangeStatus() {
    setChangeStatus(null);
  }

  const onChangeStatus = (e) => {
    setChangeStatus((prev) => ({
      ...prev,
      machine_status: e.target.value,
    }));
  };

  const prosesChangeStatus = async () => {
    try {
      const response = await machineProfile.updateStatus(
        changeStatus.id,
        changeStatus.machine_status
      );
      if (response.ok) {
        const body = await response.json();
        if (body.success) {
          toast.success("Machine Status has been changed");

          setChangeStatus(null);
        } else {
          toast.error(body.message);
        }
      }
    } catch (e) {
      toast.error(e.message);
    }
  };
  function changeOperation(value) {
    openChangeStatus(value);
  }

  const ExpandedComponent = ({ data }) => {
    return (
      <div style={{ padding: "10px" }}>
        <Card className="border-theme">
          <CardBody>
            <div className={"row"}>
              <div className="col-md-5">
                <ImageViewer src={data?.attachments?.filePhoto}></ImageViewer>
              </div>
              <div className="col-md-7">
                <div>
                  Machine Name : <b>{data?.machine_name}</b>
                </div>
                <hr />
                <div>Sensor Online Status</div>
                {data?.machine_status === "Operational" ? (
                  <div className="mb-2">
                    <table>
                      {data.machine_elements.map((cm, index) => (
                        <tr key={index}>
                          <td
                            style={{
                              width: "100px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {" "}
                            {cm.machine_element_name}
                          </td>
                          <td>
                            <i className="fa fa-chevron-right"></i>
                          </td>
                          <td style={{ padding: "0 5px" }}>
                            <span
                              className={`custom-chip tableFontSize ${
                                cm.deployments[0]?.sensor?.sensor_uptime[0]
                                  ?.on_off_status === "true"
                                  ? "chip-green"
                                  : "chip-red"
                              }`}
                              style={{
                                padding: "1px 15px 1px 15px",
                                color: "#040930",
                                background:
                                  cm.deployments[0]?.sensor?.sensor_uptime[0]
                                    ?.on_off_status === "true"
                                    ? "#71c56b"
                                    : "#ff8c87",
                                fontSize: "11px",
                              }}
                            >
                              {cm.deployments[0]?.sensor?.sensor_uptime[0]
                                ?.on_off_status === "true"
                                ? "Online"
                                : "Offline"}
                            </span>
                          </td>
                          <td>
                            {cm.deployments[0]?.sensor?.sensor_uptime[0]
                              ?.on_off_status === "true" ? null : (
                              <div>
                                <div style={{ fontSize: "10px" }}>
                                  Last Active
                                </div>
                                <div style={{ fontSize: "12px" }}>
                                  {formatDateOnly(
                                    cm.deployments[0]?.sensor?.sensor_uptime[0]
                                      ?.start_date
                                  )}
                                </div>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                    </table>
                  </div>
                ) : (
                  <div className="mt-3 mb-3 text-underline">
                    <h4>
                      {" "}
                      <b>- In {data?.machine_status} Status -</b>
                    </h4>
                  </div>
                )}

                <button
                  style={{ marginRight: "10px" }}
                  onClick={() => navigate("/machine/" + data.id)}
                  type="button"
                  className="btn btn-outline-theme"
                >
                  View Detail
                </button>
                <button
                  style={{ marginRight: "10px" }}
                  onClick={() => navigate("/sensor/live/" + data.id)}
                  type="button"
                  className="btn btn-outline-theme"
                >
                  View Live Sensor Data
                </button>
                {canUpdate && (
                  <button
                    onClick={() => navigate("/machine/edit/" + data.id)}
                    type="button"
                    className="btn btn-outline-theme"
                  >
                    <i className="fa fa-edit"></i> Edit machine
                  </button>
                )}
                {canUpdate && (
                  <button
                    onClick={() => {
                      changeOperation(data);
                    }}
                    type="button"
                    className="btn btn-outline-theme mt-3"
                  >
                    <i className="fa fa-edit"></i> Change Operation Status
                  </button>
                )}
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  };

  async function getLocation() {
    try {
      setLoading(true);
      const res = await location.list("true");
      const data = await parserAPI(res);
      let exp = [];
      function transformToTreeStructure(data) {
        const resultAll = data.map((item) => {
          const newItem = {
            name: item.location_name,
            id: item.id,
            metadata: {
              type: "dir",
            },
            children: [],
          };

          if (item.sublocations && item.sublocations.length > 0) {
            // If there are subdirectories, recursively transform them
            exp.push(item.id);
            newItem.children = transformToTreeStructure(item.sublocations);
          }

          if (item.machines && item.machines.length > 0) {
            // If there are machines, add them as children with type 'machine'
            const machineChildren = item.machines.map((machine) => ({
              name: machine.machine_name,
              id: machine.id,

              metadata: {
                location_name: item.location_name,
                type: "machine",
              },
            }));
            newItem.children = [...newItem.children, ...machineChildren];
          }

          return newItem;
        });
        return resultAll;
      }
      let result = transformToTreeStructure(data);

      setExpandedIds(exp);
      const finalResult = {
        name: "",
        children: result,
      };
      // change all the sublocations into children
      const folder = flattenTree(finalResult);
      setLocations(folder);
      // recursive add children

      setLoading(false);
    } catch (e) {
      toast.error(e.message);
      setLoading(false);
    }
  }

  const handleClickMachine = (element) => {
    //console.log({ element });
    clickMachine(element);
    // setSelectedMachine(null);
    // getMachine(element.id);
    // // get machine detail from data
    // // const machine = datas.find((d) => d.id === element.id);
    // // setSelectedMachine(machine);
    // setOpenModal(true);
  };

  useEffect(() => {
    getLocation();
  }, []);

  return (
    <div>
      <Card>
        <CardHeader>Choose Location</CardHeader>
        <CardBody>
          <Loader loading={loading}>
            <div
              style={{
                height: "calc(100vh - 341px)",
                overflowY: "auto",
                overflow: "auto",
              }}
            >
              <div className="checkboxer">
                {locations ? (
                  <TreeView
                    data={locations}
                    aria-label="Checkbox tree"
                    propagateSelect
                    expandedIds={expandedIds}
                    propagateSelectUpwards
                    togglableSelect
                    nodeRenderer={({
                      element,
                      isBranch,
                      isExpanded,
                      isSelected,
                      isHalfSelected,
                      getNodeProps,
                      level,
                      handleSelect,
                      handleExpand,
                    }) => {
                      return (
                        <div
                          {...getNodeProps({ onClick: handleExpand })}
                          style={{ marginLeft: 40 * (level - 1) }}
                        >
                          {isBranch && <ArrowIcon isOpen={isExpanded} />}
                          {element.metadata?.type === "dir" ? <></> : <></>}
                          {element.metadata?.type === "machine" ? (
                            <i
                              className="fa fa-gears"
                              style={{
                                color:
                                  element.metadata?.type === "machine"
                                    ? "#9bf7ff"
                                    : "#f5faa3",
                              }}
                            ></i>
                          ) : (
                            <i
                              className={"fa fa-warehouse"}
                              style={{
                                color:
                                  element.metadata?.type === "machine"
                                    ? "#9bf7ff"
                                    : "#f5faa3",
                              }}
                            ></i>
                          )}{" "}
                          <span
                            onClick={(e) => {
                              handleSelect(e);
                              if (element.metadata?.type === "machine") {
                                handleClickMachine(element);
                              }
                            }}
                            className="name"
                            style={{
                              color:
                                element.metadata?.type === "machine"
                                  ? "#9bf7ff"
                                  : "#f5faa3",
                            }}
                          >
                            {element.name}
                          </span>
                        </div>
                      );
                    }}
                  />
                ) : null}
              </div>
            </div>
          </Loader>
        </CardBody>
      </Card>
    </div>
  );
}

const ArrowIcon = ({ isOpen, className }) => {
  const baseClass = "arrow";
  const classes = cx(
    baseClass,
    { [`${baseClass}--closed`]: !isOpen },
    { [`${baseClass}--open`]: isOpen },
    className
  );
  return <IoMdArrowDropright className={classes} />;
};

const CheckBoxIcon = ({ variant, ...rest }) => {
  switch (variant) {
    case "all":
      return <FaCheckSquare {...rest} />;
    case "none":
      return <FaSquare {...rest} />;
    case "some":
      return <FaMinusSquare {...rest} />;
    default:
      return null;
  }
};

export default StructureView;
